<template>
  <div>
    <router-view />

    <b-modal
      ref="notifyModal"
      :title="notify.title"
      size="md"
      ok-only
      @hidden="onHidden"
    >
      <div class="d-block text-center">
        {{ notify.message }}
      </div>
    </b-modal>

    <global-toast />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ptBR from "vee-validate/dist/locale/pt_BR";
import GlobalToast from '@/components/shared/GlobalToast.vue';

export default {
  name: "App",
  components: {
    GlobalToast,
  },
  computed: {
    ...mapState({
      notify: (state) => state.notify,
    }),
  },
  methods: {
    onHidden() {
      this.$store.dispatch("notify/clean");
    },

    tryShowModal() {
      if (this.$refs.notifyModal) {
        this.$refs.notifyModal.show();
      } else {
        // TODO: Fallback
      }
    },
  },
  created() {
    this.$store.subscribeAction((action) => {
      const actionsToShowModal = ["notify/success", "notify/error"];
      if (actionsToShowModal.includes(action.type)) {
        this.tryShowModal();
      }
    });
  },
  mounted() {
    this.$validator.localize("pt_BR", {
      messages: ptBR.messages,
      attributes: {
        name: this.$t("name"),
        email: this.$t("email"),
        company: this.$t("company"),
        password: this.$t("password"),
        confirm_password: this.$t("confirm_password"),
        fantasy_name: this.$t("fantasy_name"),
        social_reason: this.$t("social_reason"),
        cpf_cnpj: this.$t("cpf_cnpj"),
        phone: this.$t("phone"),
        phone1: this.$t("phone") + " " + 1,
        phone2: this.$t("phone") + " " + 2,
        cep: this.$t("cep"),
        uf: this.$t("uf"),
        city: this.$t("city"),
        public_place: this.$t("public_place"),
        neighborhood: this.$t("neighborhood"),
        establishment_number: this.$t("establishment_number"),
        bank: this.$t("bank"),
        agency: this.$t("agency"),
        account: this.$t("account"),
        type_account: this.$t("type_account"),
        usertype: this.$t("usertype"),
        place_service: this.$t("place_service"),
        latitude: this.$t("latitude"),
        longitude: this.$t("longitude"),
        installation_value: this.$t("installation_value"),
        reinstallation_value: this.$t("reinstallation_value"),
        maintance_value: this.$t("maintance_value"),
        withdrawal_value: this.$t("withdrawal_value"),
        km_traveled_value: this.$t("km_traveled_value"),
        maintance_reason: this.$t("maintance_reason"),
        active_type: this.$t("active_type"),
        manufacturer: this.$t("manufacturer"),
        active: this.$t("active"),
        model: this.$t("model"),
        location: this.$t("location"),
        garage_accredited: this.$t("garage_accredited"),
        garage_accredited_name: this.$t("garage_accredited_name"),
        type: this.$t("type"),
        serie: this.$t("serie"),
        description: this.$t("description"),
        technical_user: this.$t("technical_user"),
        serial: this.$t("serial"),
        contract: this.$t("contract"),
        board: this.$t("board"),
        brand: this.$t("brand"),
        color: this.$t("color"),
        year: this.$t("year"),
        vehicle_type: this.$t("vehicle_type"),
        odometer: this.$t("odometer"),
        services: this.$t("services"),
        reason: this.$t("reason"),
        travel: this.$t("travel"),
        travel_km: this.$t("travel_km"),
        obs: this.$t("obs"),
        withdrawn_serial: this.$t("withdrawn_serial"),
        amount: this.$t("amount"),
        service_date: this.$t("service_date"),
        travel_payment: this.$t("travel_payment"),
        old_equipment: this.$t("old_equipment"),
        new_equipment: this.$t("new_equipment"),
        select_destination: this.$t("select_destination"),
        register_type: this.$t("register_type"),
        generate_serial: this.$t("generate_serial"),
        amount_items: this.$t("amount_items"),
        prefix: this.$t("prefix"),
        version: this.$t("version"),
        action: this.$t("action"),
        sim_card: this.$t("sim_card"),
        tracker: this.$t("tracker"),
        batch: this.$t("batch"),
        itemType: this.$t("itemType"),
        provider: this.$t("provider"),
        nf: this.$t("nf"),
        totalValueNF: this.$t("totalValueNF"),
        amountItems: this.$t("amountItems"),
        purchase_date: this.$t("purchase_date"),
        warranty_date: this.$t("warranty_date"),
        minimum: this.$t("minimum"),
        alert_message: this.$t("alert_message"),
        title: this.$t("title"),
        suspend_until: this.$t("suspend_until"),
        lost_by: this.$t("lost_by"),
        responsible_email: this.$t("responsible_email"),
        cpf: this.$t("cpf"),
        cnpj: this.$t("cnpj"),
        installation_date: this.$t("installation_date"),
        code: this.$t("code"),
        client: this.$t("client"),
        module_model: this.$t("module_model"),
        origin: this.$t("origin"),
        destiny: this.$t("destiny"),
        originDirectory: this.$t("originDirectory"),
        destinyDirectory: this.$t("destinyDirectory"),
        sendedDirectory: this.$t("sendedDirectory"),
        route_name: this.$t("route_name"),
        start_lunch: this.$t("start_lunch"),
        end_lunch: this.$t("end_lunch"),
        duration_lunch: this.$t("duration_lunch"),
        type: this.$t("type"),
        duration: this.$t("duration"),
        start: this.$t("start"),
        end: this.$t("end"),
        keep_filename: this.$t("keep_filename"),
        use_one_register_by_lote: this.$t("use_one_register_by_lote"),
        endpointDeliveries: this.$t("endpointDeliveries"),
        endpointLocalization: this.$t("endpointLocalization"),
        endpointApiFrotix: this.$t("endpointApiFrotix"),
        endpointApiMongo: this.$t("endpointApiMongo"),
        service_local: this.$t("service_local"),
        consultant: this.$t("consultant"),
        infraction_level: this.$t("infraction_level"),
        infraction_type_description: this.$t("infraction_type_description"),
        infraction_type_code: this.$t("infraction_type_code"),
      },
    });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (const registration of registrations) {
          registration.unregister().then(() => {
            console.log('Service Worker desregistrado:', registration)
          })
        }
      })
    }
  },
};
</script>
